import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({
	MyFavorites: {
		k: "my.favorites",
		v: "My Favorites"
	},
	MySavedSearchs: {
		k: "my.saved.searchs",
		v: "My Saved Searchs"
	},
	ContentItems: {
		k: "content.item",
		v: "# Content Items"
	},
	SearchName: {
		k: "search.name",
		v: "Search Name"
	},
	Actions: {
		k: "actions",
		v: "Actions"
	},
	MyPlaylist: {
		k: "my.playlist",
		v: "My Playlist"
	},
	PlaylistTitle: {
		k: "playlist.title",
		v: "Title"
	},
	ContentType: {
		k: "content.type",
		v: "Content Type"
	},
	FavoriteEmpty: {
		k: "favorite.empty.title",
		v: "No favorite Found"
	},
	FavoriteEmptyDescription: {
		k: "favorite.empty.description",
		v: "Save Search to begin"
	}
});



// WEBPACK FOOTER //
// ./src/panels/favorites/Favorites.labels.ts